<template>
	<div class="login-container">
		<div class="back-box">
			<div class="con-div">
				<div class="con-name"> 卡密核销系统</div>
				<div class="login-box">
					<div class="login-content">
						<span>欢迎登陆</span>
					</div>
					<div class="login-input-box">
						<div class="login-input-div">
							<div class="input-icon"><span class="iconfont">&#xe602;</span></div>							
							<el-input size="medium" class="login-input" placeholder="请输入用户名" v-model="username" clearable></el-input>
						</div>
						<div class="login-input-div">
							<div class="input-icon"><span class="iconfont">&#xe625;</span></div>							
							<el-input size="medium" type="password" class="login-input" placeholder="请输入密码" v-model="password" show-password></el-input>
						</div>
						
						<div class="login-input-div code-input-div">
							<div class="input-icon"><span class="iconfont">&#xe7ab;</span></div>							
							<el-input size="medium" class="code-input login-input" placeholder="请输入验证码" v-model="code"></el-input>
							<div class="code-img-div" @click="getCaptcha"><img :src="qrCodeUrl"/></div>
						</div>
					
					</div>

					<div class="login-btn"><el-button @click="login()" size="medium" class="" type="primary" style="width: 100%;" :disabled="loading">登 录</el-button></div>
					
				</div>
			</div>
			
		</div>
		
	</div>
</template>

<script>
	// import QRCode from 'qrcodejs2'
	// import local from '@/util/local'
	import axios from 'axios'
	import {
		isEmpty,
		isPositiveNumber,
		isMoney
	} from '@/util/validate'
	import {
		Message
	} from 'element-ui'
	export default {
		name: 'Login',
		data() {
			return {
				username:'',
				password:'',
				code:'',				
				loading:false,
				qrCodeBaseUrl:`${this.$baseURL}/login/getCaptcha`,
				qrCodeUrl:'',
			}
		},
		created() {
			this.getCaptcha()
		},
		mounted(){
			let self = this
			document.onkeydown = function(e) {
			  let ev = document.all ? window.event : e
			  if (ev.keyCode === 13) {
				  if(!self.loading){
					  self.login()
				  }
				
			  }
			}
		},
		destroyed() {
			document.onkeydown = null
		},
		watch: {},
		methods: {
			//获取验证码图片
			async getCaptcha(){
				// 在 URL 后面加上时间戳，防止浏览器缓存
				// this.qrCodeUrl = `${this.qrCodeBaseUrl}?_t=${Date.now()}`;
				try {
					const response = await axios.get(`${this.$baseURL}/login/getCaptcha`, {	responseType: "blob",	withCredentials: true });// 允许携带 cookie					
					this.qrCodeUrl = URL.createObjectURL(response.data);
				} catch (error) {
					console.error("验证码获取失败", error);
				}

			},
			login(){
				if(isEmpty(this.username,"请输入账号")){
					return
				}
				if(isEmpty(this.password,"请输入密码")){
					return
				}
				if(isEmpty(this.code,"请输入验证码")){
					return
				}
				let data={
					username:this.username,
					password:this.$md5(this.password),
					code:this.code,
				}
				this.loading = true
				
				

				// this.$local.set('username','aba');
				// this.$local.set('tid','txpecmwkqtomsxpiqqkvzbrflpjhqjsz');						
				// this.$router.push('./dashboard')


				this.$api.dologin(data).then(res => {
					this.loading = false
					if(res.status === 1){
						let data = res.data	
						this.$local.set('username',data.username);
						this.$local.set('tid',data.tid);	
						this.$local.set('manage',data.manage)	
						// if(data.manage){
						// 	let routes = this.$router.options.routes;
						// 	console.log(routes,'====routes====')
						// 	for(let i = 0; i< routes.length; i++){
						// 		// if(routes[i].name == 'ChildAccount' || routes[i].name == 'OperationLogs'){
						// 			routes[i].directory = true
						// 		// }
						// 	}
						// 	this.$parent.getNav()
						// }else{
						// 	let routes = this.$router.options.routes;
						// 	for(let i = 0; i< routes.length; i++){
						// 		routes[i].directory = false
						// 		if(routes[i].name == 'Dashboard' || routes[i].name == 'Setting' || routes[i].name == 'ResetPassword'){
						// 			routes[i].directory = true
						// 		}
						// 	}
							// this.$parent.getNav()
						// }
						
						this.$parent.getNav()
						this.$router.push('./dashboard')
						this.$parent.username = data.username
					}else if(res.status === 4){//验证码错误 重新获取验证码
						this.getCaptcha()
						this.$message({
						  type: 'error',
						  message: res.msg
						}); 
					}else{
						this.$message({
						  type: 'error',
						  message: res.msg
						}); 
					}
				}).catch(error=>{
					this.loading = false
				})
			},
			close(){
				
			},
		
		
		}
	}
</script>
<style lang="scss" >
	.login-input{
		width: 100%;
		input{
			padding-left: 32px !important;
		}
	}
</style>
<style lang="scss" scoped>
	.login-container {
		
		background: #006EFF;
		background-size: cover;
		.back-box{
			height: 100vh;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			.con-div{
				margin-bottom: 100px;
				border-radius: 12px;
				width: 440px;
				.con-name{
					color: #fff;
					margin-bottom: 55px;
					font-size: 48px;
					text-align: center;
				}
				.login-box{
					border-radius: 20px;
					background-color: #fff;
					padding: 30px 30px 60px;
					width: 440px;
					height: 460px;	
					box-sizing: border-box;
					.login-content{
						text-align: center;
						font-size:32px;
						color:#333333;
						margin-bottom:56px;
					}
					.login-input-box{
						margin-bottom:48px;
						// display: flex;
						// flex-direction: column;
						// justify-content:space-between;
						// align-items: flex-start;
						.login-input-div{
							width: 100%;
							position: relative;
							margin-bottom: 25px;
							.input-icon{
								position: absolute;
								left:0;
								top:0;
								// transform:translate(0,-50%)
								width:32px;
								height:100%;
								display: flex;
								justify-content:center;
								align-items: center;
								z-index:1;
								color: #808695;
							}
							.login-input{
								width: 100%;
							}
							&.code-input-div{
								display: flex;
								.code-img-div{
									width: 110px;
									margin-left: 10px;
									border: solid 1px #DCDEE2;
									img{
										width: 100%;
										height: 100%;
									}
								}
							}
							
						}
					}
					.login-btn{

					}

				}
			}
		}
		
		
		
		
	}
	
</style>
